import { useEffect, useState } from "react";
import { apiGet, apiPost } from '../../API/httpCommon';
import Spinner from '../Spinner/Spinner';
import { setUserDetails, getUserDetails } from '../../Utility/UserUtility';
import { useNavigate } from 'react-router-dom';
import { format, addDays } from 'date-fns';

const Order = () =>{

     const navigate = useNavigate();

     const [isLoading, setIsLoading] = useState(false);
     const [OrderList, setOrderList] = useState<any[]>([]);

    useEffect(function(){
        
        let userDetails : any = getUserDetails();
        if(userDetails?.User?.User_Id){
            GetOrder();
        }
        else{
            navigate('/');
        }

       

    },[]);

 const GetOrder = () => {
        setIsLoading(true);
        let userDetails : any = getUserDetails();
        apiGet(`api/Order/GetOrder?User_Id=${userDetails?.User?.User_Id}`).then((res: any) => {
            
            setOrderList(res?.Data);
         setIsLoading(false);
    });
}

const handleViewDetail = (OrderId : any) =>{

    navigate('/OrderStatus?oid='+OrderId);

}


    return(<>
     {(isLoading && <Spinner></Spinner>)} 
     <div className=" breadcrumb-padding-180"></div>
    <div className="cart-section section-padding">
        <div className="container">
			<div className="section-title-area">
                <div className="section-title center">
                    <h3 className="wow fadeInUp" data-wow-delay=".3s"><br/>Order History	</h3>
                </div>
            </div>
            <div className="main-cart-wrapper">
			
                <div className="row g-5">
                    <div className="col-xl-12 Cancel">
                        <div className="table-responsive ">
						
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="cart-border">Order ID</th>
                                        <th className="cart-border">Order Amount</th>
                                        <th className="cart-border">Order Date</th>
                                        <th className="cart-border">Payment Mode</th>
                                        <th className="cart-border">Status</th>
                                        <th className="cart-border">Details</th>
                                    </tr>
									<tr className="border-bottom"></tr>
                                </thead>
								
								
							
                                <tbody>
									
                                   {
                                        OrderList?.map(item =>(
                                            
<tr>
                                        <td className="cart-border">
                                            <span className="cart-title">{item?.Order_Id}</span>
                                        </td>
										 <td className="cart-border">
                                            <span className="cart-title">{item?.Order_Amount}	</span>
                                        </td>
										<td className="cart-border">
                                            <span className="cart-title">{format(item?.Order_Date, "dd-MMM-yyyy hh:mm a")}	</span>
                                        </td>
                                        <td className="cart-border">
                                            <span className="cart-title">{item?.PaymentMode}</span>
                                        </td>
										 <td className="cart-border">
                                            <span className="cart-title">{item?.Order_ShipStatus}</span>
                                        </td>
										
										 <td className="cart-border">
                                           
                                         
                                             <span className="cart-title"><a className="theme-btn" onClick={() => handleViewDetail(item?.Order_Id)} >View Detail</a></span>
                                             {/* &nbsp;  {item?.Order_ShipStatus !== 'Cancelled' && item?.Order_ShipStatus !== 'Returned' && item?.Order_ShipStatus !== 'Undelivered' && <span className="cart-title"><a href="#" className="theme-btn">Invoice</a></span>  }  */}
                                        </td>
                                    </tr>

                                        ))

                                   } 
                                    
                                   
                                </tbody>
                            </table>
                        </div>
                        
                    </div>
                    
                </div>
            </div>
        </div>
    </div>


    </>);
}

export default Order;